<dcr-dialog
  [open]="open"
  type="custom"
  headline="Gesprek opnieuw bekijken"
  fullscreen
  centeredContent
  (closed)="onDialogClosed()"
  >
  @if (detail$ | async; as detail) {
    <div class="[ flex flex-wrap gap-2xs m-be-m ]">
      <span class="[ surface-container corner-full p-i-s p-b-3xs label-small text-secondary ]">
        Doeltaal: <strong class="text-on-surface">{{ detail.targetLang }}</strong>
      </span>
      @if (detail.tutorLang) {
        <span class="[ surface-container corner-full p-i-s p-b-3xs label-small text-secondary ]">
          Interface: <strong class="text-on-surface">{{ detail.tutorLang }}</strong>
        </span>
      }
      @if (detail.startDate) {
        <span class="[ surface-container corner-full p-i-s p-b-3xs label-small text-secondary ]">
          {{ detail.startDate | date: 'short' }}
        </span>
      }
    </div>

    <div class="[ stack stack-space-m ]">
      @for (message of toReviewMessages(detail); track message) {
        <article
          class="dialog-review__row [ flex gap-3xs items-start ]"
          [class.dialog-review__row--user]="!message.isBot"
          >
          <dcr-avatar
            class="dialog-review__avatar"
            readonly
            [firstName]="message.authorFirstName"
            [lastName]="message.authorLastName"
            [imageUrl]="message.authorAvatar"
            [showInitials]="!message.authorAvatar"
          ></dcr-avatar>

          <div class="dialog-review__column [ stack stack-space-3xs ]">
            <span class="[ label-small text-secondary p-i-3xs ]">{{ message.authorLabel }}</span>

            <div
              class="dialog-review__bubble [ p-s corner-l ]"
              [class.surface-container-highest]="message.isBot"
              [class.primary-container]="!message.isBot"
            >
              <p class="[ body-medium m-none ]">
                @for (segment of message.segments; track segment) {
                  @if (segment.feedbackComment) {
                    <span
                      class="dialog-review__highlight"
                      [attr.data-feedback-type]="segment.feedbackType"
                      [title]="segment.feedbackComment"
                      >{{ segment.text }}</span>
                  } @else {
                    <span>{{ segment.text }}</span>
                  }
                }
              </p>

              @if (message.fragmentUrl) {
                <audio class="dialog-review__audio [ block m-bs-3xs ]" controls [src]="message.fragmentUrl"></audio>
              }
            </div>

            @if (message.feedbackCount) {
              <ul class="[ stack stack-space-3xs p-none m-none ]">
                @for (segment of message.segments; track segment) {
                  @if (segment.feedbackCommentParts?.length) {
                    <li class="[ flex gap-3xs items-baseline label-small text-secondary ]">
                      <span
                        class="dialog-review__feedback-type [ corner-full p-i-3xs ]"
                        [attr.data-feedback-type]="segment.feedbackType"
                      >{{ segment.feedbackType | lowercase }}</span>
                      <span>
                        @for (part of segment.feedbackCommentParts; track part) {
                          @if (part.isSuggestion) {
                            <em class="dialog-review__suggestion">{{ part.text }}</em>
                          } @else {
                            <span>{{ part.text }}</span>
                          }
                        }
                      </span>
                    </li>
                  }
                }
              </ul>
            }
          </div>
        </article>
      }
    </div>
  } @else {
    <p class="[ p-m text-secondary text-center ]">Gesprek wordt geladen…</p>
  }
</dcr-dialog>
